import { sizeTab, texto, a11yProps } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import SolicitudPedidosPrevAbiertosPagina from "./solicitud-pedidos-abierto/solicitud-pedidos-prev-abierto";
import SolicitudPedidosPrevAprobadosPagina from "./solicitud-pedidos-aprobados/solicitud-pedidos-prev-aprobados";
import SolicitudPedidosPrevRechazadosPagina from "./solicitud-pedidos-rechazados/solicitud-pedidos-prev-rechazados";
import SolicitudPedidosPrevEnesperaPagina from "./solicitud-pedido-en-espera/solicitud-pedidos-prev-espera";

export default function SolicitudPrevPedidosPagina() {

  const [valueTab, setValueTab] = useState(0);

  return (

    <SingleTableBoxScene title={"Solicitud de pedidos a revisar"} >

      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs solicitud pedidos"
        >
          
          <Tab label={texto.aprobado_pendiente_abierto} {...a11yProps(0)} />
          <Tab label={texto.solicitud_pedido_espera} {...a11yProps(1)} />
          <Tab label={texto.solicitudes_pedido_aprobadas} {...a11yProps(2)} /> 
          <Tab label={texto.solicitud_pedido_rechazada} {...a11yProps(3)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        < SolicitudPedidosPrevAbiertosPagina />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        < SolicitudPedidosPrevEnesperaPagina />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        < SolicitudPedidosPrevAprobadosPagina />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={3}>
        < SolicitudPedidosPrevRechazadosPagina />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );


}


